module.exports = __webpack_public_path__ + "static/media/003.b3e9d86a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/003.jpg
// module id = 510
// module chunks = 0